
export class CamToolHolder {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new CamToolHolder (
      this.hash,
      this.name
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/cam-tool-holder.ts